// import useCustomSnackbar from "../helper/useCustomSnackbar";
// import { useAuth } from '../user/context/AuthContext'

import { useNavigate } from "react-router-dom";
import useCustomSnackbar from "../helper/useCustomSnackbar";
import { useAuth } from "../user/context/AuthContext";

// const useRequest = () => {
//   const token = useAuth()
//   const showSnackbar = useCustomSnackbar();
//   const Request = async (url, config, headers) => {
//     let baseUrl = process.env.REACT_APP_LIVE_BASE_URL_LMS_ADMIN
//     if (headers == null) {
//       headers = new Headers()
//       headers.append('Content-Type', 'application/json; charset=utf-8')
//     }
//     if (token && url.includes('login')) {
//       headers.append('Authorization', token.token)
//       headers.append('Authorization', `Bearer ${token.token}`)
//     }
//     const result = await fetch(`${baseUrl}/${url}`, { headers: headers, ...config })
//     if (!result.ok && result.status === 401 && !url.includes('login')) {
//       let res = await result.json()
//       localStorage.clear()
//       showSnackbar('error', res?.message ? res?.message : 'Session expired, Please login again')
//       window.location.href = '/login';
//     }
//     let response;
//     try {
//       response = await result.json()
//     } catch (error) {
//       response = await result.text()
//     }
//     return response;
//   }
//   return Request;
// }

// export default useRequest;

const useRequest = () => {
  const token = useAuth();
  const showSnackbar = useCustomSnackbar();

  const navigate = useNavigate()

  const Request = async (url, config, headers, isFormData = false) => {
    let baseUrl = process.env.REACT_APP_LIVE_BASE_URL_LMS_ADMIN;

    if (!headers) {
      headers = new Headers();
      if (isFormData === false) {
        headers.append("Content-Type", "application/json; charset=utf-8");
      }
    }
    if (token) {
      headers.append("Authorization", `Bearer ${token.token}`);
    }

    // if (token && !url.includes("login")) {
    //   headers.append("Authorization", `Bearer ${token.token}`);
    // }

    const result = await fetch(`${baseUrl}/${url}`, { headers, ...config });

    // console.log(result,'result.....')

    if (!result.ok && result.status === 403 && !url.includes("login")) {
      let res;
      try {
        res = await result.json();
      } catch (error) {
        res = { message: "Session expired, Please login again" };
      }

      localStorage.clear();
      showSnackbar("error", res?.message);
      // window.location.href = "/login";
      navigate('/login', { replace: true })
    }

    let responseBody;
    const contentType = result.headers.get("Content-Type");

    if (contentType && contentType.includes("application/json")) {
      responseBody = await result.json();
    } else {
      responseBody = await result.text();
    }

    if (!result.ok) {
      //  console.log(responseBody,'........')
      const error = new Error(responseBody?.error || `Request failed with status ${result.status}`);
      error.status = result.status;
      error.data = responseBody;
      throw error;
    }

    return responseBody;
  };

  return Request;
};

export default useRequest;
